var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "main-internal-section width-full float-l" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "chat-bottom-section-web width-full float-l" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "chat-web-left-section col-12 col-sm-12 col-md-12 col-lg-4 col-lg-4 float-l"
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { attrs: { id: "snackbar" } }, [
                        _c("span", [
                          _vm._v(
                            "Chat archived\n                                    "
                          ),
                          _c(
                            "a",
                            {
                              staticStyle: { color: "blue", cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  return _vm.undoArchiveChat()
                                }
                              }
                            },
                            [_vm._v("UNDO")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "header-section col-12 float-l bgcolor-cfe3ee"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "user-customer-title float-l colpie-78"
                            },
                            [
                              _c(
                                "ul",
                                {
                                  staticClass: "nav nav-tabs",
                                  attrs: { role: "tablist" }
                                },
                                [
                                  _c("li", { staticClass: "nav-item" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "nav-link",
                                        attrs: {
                                          "data-toggle": "tab",
                                          href: "#customer",
                                          role: "tab"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabClick("user")
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticStyle: { float: "left" } },
                                          [_vm._v("Users ")]
                                        ),
                                        _vm._v(" "),
                                        _vm.userCounter
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "chat-counter" },
                                                [
                                                  _vm._v(
                                                    "\n                                                        " +
                                                      _vm._s(_vm.userCounter) +
                                                      "\n                                                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", { staticClass: "nav-item" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "nav-link active",
                                        attrs: {
                                          id: "customerTab",
                                          "data-toggle": "tab",
                                          href: "#admin",
                                          role: "tab"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.tabClick("customer")
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticStyle: { float: "left" } },
                                          [_vm._v("Customers ")]
                                        ),
                                        _vm._v(" "),
                                        _vm.customerCounter
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "chat-counter" },
                                                [
                                                  _vm._v(
                                                    "\n                                                        " +
                                                      _vm._s(
                                                        _vm.customerCounter
                                                      ) +
                                                      "\n                                                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ])
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "right-header-section float-r" },
                            [
                              _c("div", { staticClass: "search-bar-right" }, [
                                _c("div", { staticClass: "searchbox" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.searchText,
                                        expression: "searchText"
                                      }
                                    ],
                                    staticClass: "searchbox-input",
                                    attrs: {
                                      type: "search",
                                      placeholder: "Search......",
                                      name: "search",
                                      required: ""
                                    },
                                    domProps: { value: _vm.searchText },
                                    on: {
                                      input: [
                                        function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.searchText = $event.target.value
                                        },
                                        function($event) {
                                          return _vm.searchAPI()
                                        }
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  !_vm.searchOpen
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "searchbox-icon",
                                          attrs: { href: "javascript:void(0)" },
                                          on: {
                                            click: function($event) {
                                              return _vm.searchBoxClose()
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                "/static/images/search-close.png"
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.searchOpen
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "searchbox-icon",
                                          on: {
                                            click: function($event) {
                                              return _vm.searchBoxOpen()
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "hi-icon icon-chatmagnifying-glass"
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "menu-right-header float-r" },
                            [
                              _c(
                                "div",
                                { staticClass: "nc-chat-right-dropdown" },
                                [
                                  _c("div", { staticClass: "dropdown" }, [
                                    _vm._m(0),
                                    _vm._v(" "),
                                    _c("ul", { staticClass: "dropdown-menu" }, [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "user-name color-f5911e heading-text-14 line-height-20 font-benton-bold float-l width-full"
                                        },
                                        [
                                          _vm.status == "Online" ||
                                          _vm.status == "online"
                                            ? _c("span", {
                                                staticClass:
                                                  "bgcolor-5cbb55 p_5 pull-left absolute l-15 t-5 radius-100"
                                              })
                                            : _c("span", {
                                                staticClass:
                                                  "bgcolor-ff3636 p_5 pull-left absolute l-15 t-5 radius-100"
                                              }),
                                          _vm._v(
                                            "\n                                                    " +
                                              _vm._s(_vm.userName) +
                                              "\n                                                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: { name: "SiteList" }
                                              }
                                            },
                                            [
                                              _vm._v(" My Sites "),
                                              _c("span", [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-angle-right custom"
                                                })
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.cantAccessPage === true
                                        ? _c(
                                            "li",
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: { name: "UserList" }
                                                  }
                                                },
                                                [
                                                  _vm._v(" User List "),
                                                  _c("span", [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-angle-right custom"
                                                    })
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.cantAccessPage === true
                                        ? _c(
                                            "li",
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: { name: "CustomerList" }
                                                  }
                                                },
                                                [
                                                  _vm._v(" Customer List "),
                                                  _c("span", [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-angle-right custom"
                                                    })
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.cantAccessPage === true
                                        ? _c(
                                            "li",
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: { name: "ArchivedChat" }
                                                  }
                                                },
                                                [
                                                  _vm._v(" Archived Chat "),
                                                  _c("span", [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-angle-right custom"
                                                    })
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentEnvironment &&
                                      _vm.cantAccessPage === true
                                        ? _c(
                                            "li",
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: { name: "MailList" }
                                                  }
                                                },
                                                [
                                                  _vm._v(" Mail List "),
                                                  _c("span", [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-angle-right custom"
                                                    })
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.cantAccessPage === true
                                        ? _c(
                                            "li",
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name:
                                                        "ListSectionSchedulerTime"
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(" Schedule Section "),
                                                  _c("span", [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-angle-right custom"
                                                    })
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.status == "Online" ||
                                      _vm.status == "online"
                                        ? _c(
                                            "li",
                                            { staticClass: "user-status-edit" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.chagneStatus(
                                                        "offline"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " Offline\n                                                        "
                                                  ),
                                                  _vm._m(1)
                                                ]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "li",
                                            { staticClass: "user-status-edit" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.chagneStatus(
                                                        "online"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " Online\n                                                        "
                                                  ),
                                                  _vm._m(2)
                                                ]
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "javascript:void(0)"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.logoutMobileView.apply(
                                                  null,
                                                  arguments
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(" Sign Out "), _vm._m(3)]
                                        )
                                      ])
                                    ])
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "chat-btm-section-main width-full float-l"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "tab-content float-l width-full" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "tab-pane active customer-chat-btm float-l width-full",
                                  attrs: { id: "customer", role: "tabpanel" }
                                },
                                [
                                  _vm.userArray && _vm.userArray.length > 0
                                    ? [
                                        _vm._l(_vm.userArray, function(
                                          user,
                                          userIndex
                                        ) {
                                          return [
                                            user.id != _vm.logingId
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      key: userIndex,
                                                      staticClass:
                                                        "chat-listing-user-section"
                                                    },
                                                    [
                                                      !_vm.isMobileView
                                                        ? _c(
                                                            "div",
                                                            {
                                                              key: userIndex,
                                                              staticClass:
                                                                "chat-listing-section-main pull-left width-full",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.getUserChatById(
                                                                    user.id,
                                                                    user.name,
                                                                    user.sections,
                                                                    user.roleName,
                                                                    user.email,
                                                                    user.strSectionRole
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "pull-left width-full p-15 relative"
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "filtersGetName"
                                                                          )(
                                                                            user.email,
                                                                            user.name
                                                                          )
                                                                        ) +
                                                                          "\n                                                                    "
                                                                      ),
                                                                      user.status ==
                                                                      "online"
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "bgcolor-5cbb55 border-white p_5 pull-left absolute r-1 t-1 radius-100"
                                                                            }
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "bgcolor-ff3636 border-white p_5 pull-left absolute r-1 t-1 radius-100"
                                                                            }
                                                                          )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "right-listing-detail pl_65 pull-left width-full pr_90"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "h3",
                                                                        {
                                                                          staticClass:
                                                                            "color-333333 font-benton-bold heading-text-16 line-height-20 float-l width-full mb_3"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              user.name
                                                                            )
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _vm._l(
                                                                        user.roles,
                                                                        function(
                                                                          userRole,
                                                                          userIndex1
                                                                        ) {
                                                                          return [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                key: userIndex1,
                                                                                staticClass:
                                                                                  "color-8888888 font-benton-medium heading-text-12 line-height-16 float-l width-full"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      userRole
                                                                                    ) +
                                                                                    " "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      user.unReadMessageCount >
                                                                        0 &&
                                                                      user.toId ==
                                                                        _vm.logingId
                                                                        ? _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "chat-unread-message float-l bgcolor-5cbb55 radius-100 center absolute r-60 t-10 b-10 mr-auto color-white heading-text-12"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    user.unReadMessageCount
                                                                                  ) +
                                                                                  " "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ],
                                                                    2
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "float-l",
                                                          attrs: {
                                                            href:
                                                              "javascript:void(0)"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.makeArchivedChat(
                                                                user.id,
                                                                "user"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "archive-chat-icon hi-icon icon-chatdownload absolute r-30 t-0 b-0 mr-auto bold color-878787"
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      key: "mobile" + userIndex,
                                                      staticClass:
                                                        "chat-listing-user-section-mobile"
                                                    },
                                                    [
                                                      _vm.isMobileView
                                                        ? _c(
                                                            "div",
                                                            {
                                                              key:
                                                                "mobile" +
                                                                userIndex,
                                                              staticClass:
                                                                "chat-listing-section-main pull-left width-full",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.gotoChatDetailsPage(
                                                                    user.id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "pull-left width-full p-15 relative"
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "filtersGetName"
                                                                          )(
                                                                            user.email,
                                                                            user.name
                                                                          )
                                                                        ) +
                                                                          "\n                                                                    "
                                                                      ),
                                                                      user.status ==
                                                                      "online"
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "bgcolor-5cbb55 border-white p_5 pull-left absolute r-1 t-1 radius-100"
                                                                            }
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "bgcolor-ff3636 border-white p_5 pull-left absolute r-1 t-1 radius-100"
                                                                            }
                                                                          )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "right-listing-detail pl_65 pull-left width-full pr_90"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "h3",
                                                                        {
                                                                          staticClass:
                                                                            "color-333333 font-benton-bold heading-text-16 line-height-20 float-l width-full mb_3"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "filterCamelCase"
                                                                              )(
                                                                                user.name
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _vm._l(
                                                                        user.roles,
                                                                        function(
                                                                          userRole,
                                                                          userIndex1
                                                                        ) {
                                                                          return [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                key:
                                                                                  "mobile" +
                                                                                  userIndex1,
                                                                                staticClass:
                                                                                  "color-8888888 font-benton-medium heading-text-12 line-height-16 float-l width-full"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      userRole
                                                                                    ) +
                                                                                    " "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          staticClass:
                                                                            "float-l",
                                                                          attrs: {
                                                                            href:
                                                                              "javascript:void(0)"
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.gotoChatDetailsPage(
                                                                                user.id
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "view-detail-icon fa fa-angle-right absolute r-8 t-0 b-0 mr-auto bold color-878787"
                                                                            }
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      user.unReadMessageCount >
                                                                        0 &&
                                                                      user.toId ==
                                                                        _vm.logingId
                                                                        ? _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "chat-unread-message float-l bgcolor-5cbb55 radius-100 center absolute r-60 t-10 b-10 mr-auto color-white heading-text-12"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    user.unReadMessageCount
                                                                                  ) +
                                                                                  " "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ],
                                                                    2
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "float-l user-mobile-archived-chat",
                                                          attrs: {
                                                            href:
                                                              "javascript:void(0)"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.makeArchivedChat(
                                                                user.id,
                                                                "user"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "archive-chat-icon hi-icon icon-chatdownload absolute r-30 t-0 b-0 mr-auto bold color-878787"
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e()
                                          ]
                                        })
                                      ]
                                    : [
                                        _vm.requestComplete
                                          ? [
                                              _vm.isMobileView
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "no-user-found"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    No User Found!\n                                                "
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "no-user-found"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    No User Found!\n                                                "
                                                      )
                                                    ]
                                                  )
                                            ]
                                          : _vm._e()
                                      ]
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "tab-pane customer-chat-btm float-l width-full",
                                  attrs: { id: "admin", role: "tabpanel" }
                                },
                                [
                                  _vm.customerArray &&
                                  _vm.customerArray.length > 0
                                    ? [
                                        _vm._l(_vm.customerArray, function(
                                          customer,
                                          customerIndex
                                        ) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                key: customerIndex,
                                                staticClass:
                                                  "chat-listing-user-section"
                                              },
                                              [
                                                !_vm.isMobileView
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "chat-listing-section-main pull-left width-full",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.getUserChatById(
                                                              customer.id,
                                                              customer.name,
                                                              customer.sections,
                                                              customer.roleName,
                                                              customer.email,
                                                              ""
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "pull-left width-full p-15 relative"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "filtersGetName"
                                                                    )(
                                                                      customer.email,
                                                                      customer.name
                                                                    )
                                                                  ) +
                                                                    "\n                                                                "
                                                                ),
                                                                customer.status ==
                                                                "online"
                                                                  ? _c("span", {
                                                                      staticClass:
                                                                        "bgcolor-5cbb55 border-white p_5 pull-left absolute r-1 t-1 radius-100"
                                                                    })
                                                                  : _c("span", {
                                                                      staticClass:
                                                                        "bgcolor-ff3636 border-white p_5 pull-left absolute r-1 t-1 radius-100"
                                                                    })
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "right-listing-detail pl_65 pull-left width-full pr_90"
                                                              },
                                                              [
                                                                _c(
                                                                  "h3",
                                                                  {
                                                                    staticClass:
                                                                      "color-333333 font-benton-bold heading-text-16 line-height-20 float-l width-full mb_3"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "filterCamelCase"
                                                                        )(
                                                                          customer.name
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _vm._l(
                                                                  customer.roles,
                                                                  function(
                                                                    customerRole,
                                                                    customerIndex1
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          key: customerIndex1,
                                                                          staticClass:
                                                                            "color-888888 font-benton-medium heading-text-12 line-height-16 float-l width-full"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                customerRole
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                customer.unReadMessageCount >
                                                                  0 &&
                                                                customer.toId ==
                                                                  _vm.logingId
                                                                  ? _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "chat-unread-message float-l bgcolor-5cbb55 radius-100 center absolute r-60 t-10 b-10 mr-auto color-white heading-text-12"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              customer.unReadMessageCount
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              2
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "float-l",
                                                    attrs: {
                                                      href: "javascript:void(0)"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.makeArchivedChat(
                                                          customer.id,
                                                          "customer"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "archive-chat-icon hi-icon icon-chatdownload absolute r-30 t-0 b-0 mr-auto bold color-878787"
                                                    })
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                key: "mobile" + customerIndex,
                                                staticClass:
                                                  "chat-listing-user-section-mobile"
                                              },
                                              [
                                                _vm.isMobileView
                                                  ? _c(
                                                      "div",
                                                      {
                                                        key:
                                                          "mobile" +
                                                          customerIndex,
                                                        staticClass:
                                                          "chat-listing-section-main pull-left width-full",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.gotoChatDetailsPage(
                                                              customer.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "pull-left width-full p-15 relative"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "filtersGetName"
                                                                    )(
                                                                      customer.email,
                                                                      customer.name
                                                                    )
                                                                  ) +
                                                                    "\n                                                                "
                                                                ),
                                                                customer.status ==
                                                                "online"
                                                                  ? _c("span", {
                                                                      staticClass:
                                                                        "bgcolor-5cbb55 border-white p_5 pull-left absolute r-1 t-1 radius-100"
                                                                    })
                                                                  : _c("span", {
                                                                      staticClass:
                                                                        "bgcolor-ff3636 border-white p_5 pull-left absolute r-1 t-1 radius-100"
                                                                    })
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "right-listing-detail pl_65 pull-left width-full pr_90"
                                                              },
                                                              [
                                                                _c(
                                                                  "h3",
                                                                  {
                                                                    staticClass:
                                                                      "color-333333 font-benton-bold heading-text-16 line-height-20 float-l width-full mb_3"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "filterCamelCase"
                                                                        )(
                                                                          customer.name
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _vm._l(
                                                                  customer.roles,
                                                                  function(
                                                                    customerRole,
                                                                    customerIndex1
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          key: customerIndex1,
                                                                          staticClass:
                                                                            "color-888888 font-benton-medium heading-text-12 line-height-16 float-l width-full"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                customerRole
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "float-l",
                                                                    attrs: {
                                                                      href:
                                                                        "javascript:void(0)"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.gotoChatDetailsPage(
                                                                          customer.id
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "view-detail-icon fa fa-angle-right absolute r-8 t-0 b-0 mr-auto bold color-878787"
                                                                    })
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                customer.unReadMessageCount >
                                                                  0 &&
                                                                customer.toId ==
                                                                  _vm.logingId
                                                                  ? _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "chat-unread-message float-l bgcolor-5cbb55 radius-100 center absolute r-60 t-10 b-10 mr-auto color-white heading-text-12"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              customer.unReadMessageCount
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              2
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "float-l user-mobile-archived-chat",
                                                    attrs: {
                                                      href: "javascript:void(0)"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.makeArchivedChat(
                                                          customer.id,
                                                          "customer"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "archive-chat-icon hi-icon icon-chatdownload absolute r-30 t-0 b-0 mr-auto bold color-878787"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        })
                                      ]
                                    : [
                                        _vm.requestComplete
                                          ? [
                                              _vm.isMobileView
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "no-user-found"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    No Customer Found!\n                                                "
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "no-user-found"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    No Customer Found!\n                                                "
                                                      )
                                                    ]
                                                  )
                                            ]
                                          : _vm._e()
                                      ]
                                ],
                                2
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.clickChatFlag
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "chat-web-right-section col-12 col-sm-12 col-md-12 col-lg-8 col-lg-8 float-l"
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "header-section col-12 float-l bgcolor-cfe3ee"
                            },
                            [
                              _vm._m(4),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "customer-name float-l colpie-87"
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "user-avtar-img float-l font-roboto-bold heading-text-14 line-height-16 bgcolor-d7b081 color-white"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("filtersGetName")(
                                              _vm.email,
                                              _vm.name
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "color-231f20 font-roboto-bold heading-text-16 line-height-20 agent-customer-name float-l width-full pt_1 pl_82 mb_0",
                                      on: {
                                        click: function($event) {
                                          return _vm.toggleCustomerDetailsDiv()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("filterCamelCase")(_vm.name)
                                        ) +
                                          "\n                                        "
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "color-58595b font-benton-medium heading-text-11 line-height-15 float-l width-full pt_2"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.strSectionRole) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.role == "guest" || _vm.role == "Guest"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "hideShowDiv customer-name float-l colpie-87"
                                    },
                                    [
                                      _c(
                                        "ul",
                                        { staticClass: "list-group" },
                                        [
                                          _c(
                                            "li",
                                            { staticClass: "list-group-item" },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-user"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.customerDetails.name
                                                  )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            { staticClass: "list-group-item" },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-envelope"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.customerDetails.email
                                                  )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            { staticClass: "list-group-item" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-phone-square"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.customerDetails.phone
                                                  )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.customerDetails
                                            .dealership_location != ""
                                            ? [
                                                _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "list-group-item"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-map-marker"
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.customerDetails
                                                            .dealership_location
                                                        )
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            { staticClass: "list-group-item" },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-book"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.customerDetails.subject
                                                  )
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.role == "guest" || _vm.role == "Guest"
                                ? _c(
                                    "div",
                                    { staticClass: "right-header-btn float-l" },
                                    [
                                      _c(
                                        "ul",
                                        { staticClass: "float-l width-full" },
                                        [
                                          _vm._m(5),
                                          _vm._v(" "),
                                          _vm._m(6),
                                          _vm._v(" "),
                                          _c("li", [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.sendMessage(
                                                      "EndChat"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._m(7), _vm._v(" End Chat ")]
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._m(8),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "menu-right-header float-r" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "nc-chat-right-dropdown" },
                                    [
                                      _c("div", { staticClass: "dropdown" }, [
                                        _vm._m(9),
                                        _vm._v(" "),
                                        _c(
                                          "ul",
                                          { staticClass: "dropdown-menu" },
                                          [
                                            _vm._m(10),
                                            _vm._v(" "),
                                            _vm._m(11),
                                            _vm._v(" "),
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "javascript:void(0)"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.sendMessage(
                                                        "EndChat"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(" End Chat "),
                                                  _vm._m(12)
                                                ]
                                              )
                                            ])
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.fileUploaded,
                                  expression: "fileUploaded"
                                }
                              ],
                              staticClass:
                                "chat-btm-section-main chat-listing-main-mobile width-full float-l"
                            },
                            [
                              _c("form", [
                                _c("input", {
                                  ref: "fileInput",
                                  staticStyle: { display: "none" },
                                  attrs: { type: "file", multiple: "" },
                                  on: { change: _vm.handleFiles }
                                })
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.filesPreview, function(file, index) {
                                return _vm.filesPreview
                                  ? _c("div", [
                                      _c("h3", [_vm._v("File Preview:")]),
                                      _vm._v(" "),
                                      _vm.isImage(file.type)
                                        ? _c("img", {
                                            staticStyle: {
                                              "max-width": "200px"
                                            },
                                            attrs: {
                                              src: file.src,
                                              alt: "File Preview"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isPdf(file.type)
                                        ? _c("iframe", {
                                            staticStyle: {
                                              width: "60%",
                                              height: "200px"
                                            },
                                            attrs: {
                                              src: file.src,
                                              frameborder: "0"
                                            }
                                          })
                                        : _c("div", [
                                            _vm._v(
                                              "File Name: " + _vm._s(file.name)
                                            )
                                          ]),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "remove-button",
                                          on: {
                                            click: function($event) {
                                              return _vm.removeFile(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-times"
                                          }),
                                          _vm._v(
                                            " Remove\n                                "
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              }),
                              _vm._v(" "),
                              _c(
                                "form",
                                { staticClass: "send-message-form-class" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "btm-chat-textarea float-l col-12"
                                    },
                                    [
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.messageData,
                                            expression: "messageData"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "msgTextArear",
                                          type: "text",
                                          placeholder:
                                            "Type your message here...",
                                          name: "message"
                                        },
                                        domProps: { value: _vm.messageData },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.messageData =
                                                $event.target.value
                                            },
                                            function($event) {
                                              return _vm.typingEvent()
                                            }
                                          ]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "help is-danger" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.message_text_error_msg)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "send-message-btn float-l"
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                id: "sendMessage",
                                                href: "javascript:void(0)"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.sendMessage("Chat")
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "hi-icon icon-chatplay-button"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.fileUploaded,
                                  expression: "!fileUploaded"
                                }
                              ],
                              staticClass: "drop-zone width-full custom-des",
                              attrs: { id: "dropZone" },
                              on: {
                                dragover: function($event) {
                                  $event.preventDefault()
                                  return _vm.dragOver.apply(null, arguments)
                                },
                                dragleave: _vm.dragLeave,
                                drop: _vm.drop
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "chat-btm-section-main chat-listing-main-mobile width-full float-l message-height"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "chat-detail-main col-12 float-l"
                                    },
                                    [
                                      _vm._l(_vm.messageArray, function(
                                        message
                                      ) {
                                        return _vm.messageArray &&
                                          _vm.messageArray.length > 0
                                          ? [
                                              message.fromId != _vm.logingId
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "user-chat-main colpie-85 float-l"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "user-img float-l"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "filtersGetName"
                                                                    )(
                                                                      _vm.email,
                                                                      _vm.name
                                                                    )
                                                                  ) +
                                                                  "\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "user-massage float-l width-full"
                                                        },
                                                        [
                                                          _c("p", {
                                                            staticClass:
                                                              "message-content color-333333 heading-text-14 line-height-20 float-l bgcolor-eff1f1 font-text-regular-benton radius-5 pt_10 p_12 mb_0",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                message.message
                                                              )
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "date color-888888 heading-text-11 line-height-16 float-l width-full font-text-regular-benton mb_0 pt_5 pl_12"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "filterDate"
                                                                  )(
                                                                    message.created_date
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "admin-chat-main colpie-82 float-r"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "user-massage float-r width-full"
                                                        },
                                                        [
                                                          _c("p", {
                                                            staticClass:
                                                              "message-content color-333333 heading-text-14 line-height-20 float-r bgcolor-d6eef5 font-text-regular-benton radius-5 pt_10 p_12 mb_0",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                message.message
                                                              )
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "date color-888888 heading-text-11 line-height-16 float-r right width-full font-text-regular-benton mb_0 pt_5 pr_12"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "filterDate"
                                                                  )(
                                                                    message.created_date
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          message.isFailed
                                                            ? _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "message-failed date color-888888 heading-text-11 line-height-16 float-r right width-full font-text-regular-benton mb_0 pt_5 pr_12"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Message Sending Failed"
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  )
                                            ]
                                          : _vm._e()
                                      }),
                                      _vm._v(" "),
                                      _vm.isHideType
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "message-typing float-r width-full"
                                            },
                                            [_vm._m(13)]
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "form",
                                { staticClass: "send-message-form-class" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "btm-chat-textarea float-l col-12"
                                    },
                                    [
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.messageData,
                                            expression: "messageData"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "msgTextArear",
                                          type: "text",
                                          placeholder:
                                            "Type your message here...",
                                          name: "message"
                                        },
                                        domProps: { value: _vm.messageData },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.messageData =
                                                $event.target.value
                                            },
                                            function($event) {
                                              return _vm.typingEvent()
                                            }
                                          ]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "help is-danger" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.message_text_error_msg)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "send-message-btn float-l"
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                id: "sendMessage",
                                                href: "javascript:void(0)"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.triggerFileInput.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-paperclip"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                id: "sendMessage",
                                                href: "javascript:void(0)"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.sendMessage("Chat")
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "hi-icon icon-chatplay-button"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            ref: "fileInput",
                            staticStyle: { display: "none" },
                            attrs: { type: "file", multiple: "" },
                            on: {
                              click: _vm.triggerFileInput,
                              change: _vm.handleFiles
                            }
                          })
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade forward-chat-modal",
          attrs: {
            id: "basicModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "basicModal",
            "aria-hidden": "true"
          }
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("div", { staticClass: "modal-header" }, [
                  _vm._m(14),
                  _vm._v(" "),
                  _c(
                    "h4",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "myModalLabel" }
                    },
                    [_vm._v("Forward Message To")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "nc-search" }, [
                    _c(
                      "div",
                      { staticClass: "input-group stylish-input-group" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchText,
                              expression: "searchText"
                            }
                          ],
                          staticClass: "form-control fName",
                          attrs: {
                            type: "text",
                            placeholder: "Search",
                            id: "forName"
                          },
                          domProps: { value: _vm.searchText },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.searchText = $event.target.value
                              },
                              function($event) {
                                return _vm.searchAPI("forwardChat")
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "input-group-addon" })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                [
                  _vm.userArray && _vm.userArray.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "modal-body forward-chat-main float-l width-full p_0"
                        },
                        _vm._l(_vm.userArray, function(user, index) {
                          return _c(
                            "div",
                            { key: index },
                            [
                              user.roleName != "" && user.sections != ""
                                ? [
                                    user.id != _vm.logingId
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "chat-listing-section-main chat-forward-section pull-left width-full"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "pull-left width-full p-15 relative"
                                                },
                                                [
                                                  user.status == "online"
                                                    ? [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "filtersGetName"
                                                                  )(
                                                                    user.email,
                                                                    user.name
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                            _c("span", {
                                                              staticClass:
                                                                "bgcolor-5cbb55 border-white p_5 pull-left absolute r-1 t-1 radius-100"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "filtersGetName"
                                                                  )(
                                                                    user.email,
                                                                    user.name
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                            _c("span", {
                                                              staticClass:
                                                                "bgcolor-dc3545 border-white p_5 pull-left absolute r-1 t-1 radius-100"
                                                            })
                                                          ]
                                                        )
                                                      ],
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "right-listing-detail pl_65 pull-left width-full pr_35 custom-checkbox"
                                                    },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          staticClass:
                                                            "color-333333 font-benton-bold heading-text-15 line-height-19 float-l width-full mb_3"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "filterCamelCase"
                                                                )(user.roleName)
                                                              ) +
                                                              "(" +
                                                              _vm._s(
                                                                user.email
                                                              ) +
                                                              ")"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "color-8888888 font-benton-medium heading-text-12 line-height-16 float-l width-full"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "filterCamelCase"
                                                                )(user.sections)
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "radiobutton"
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "custom-radio-container"
                                                            },
                                                            [
                                                              user.status ==
                                                              "offline"
                                                                ? [
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.radioBtnId,
                                                                            expression:
                                                                              "radioBtnId"
                                                                          }
                                                                        ],
                                                                        attrs: {
                                                                          type:
                                                                            "radio",
                                                                          name:
                                                                            "chat",
                                                                          disabled:
                                                                            ""
                                                                        },
                                                                        domProps: {
                                                                          value:
                                                                            user.id,
                                                                          checked: _vm._q(
                                                                            _vm.radioBtnId,
                                                                            user.id
                                                                          )
                                                                        },
                                                                        on: {
                                                                          change: function(
                                                                            $event
                                                                          ) {
                                                                            _vm.radioBtnId =
                                                                              user.id
                                                                          }
                                                                        }
                                                                      }
                                                                    )
                                                                  ]
                                                                : [
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.radioBtnId,
                                                                            expression:
                                                                              "radioBtnId"
                                                                          }
                                                                        ],
                                                                        attrs: {
                                                                          type:
                                                                            "radio",
                                                                          name:
                                                                            "chat"
                                                                        },
                                                                        domProps: {
                                                                          value:
                                                                            user.id,
                                                                          checked: _vm._q(
                                                                            _vm.radioBtnId,
                                                                            user.id
                                                                          )
                                                                        },
                                                                        on: {
                                                                          change: function(
                                                                            $event
                                                                          ) {
                                                                            _vm.radioBtnId =
                                                                              user.id
                                                                          }
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                              _vm._v(" "),
                                                              _c("span", {
                                                                staticClass:
                                                                  "checkmark"
                                                              })
                                                            ],
                                                            2
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ],
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "chat-forward-btm float-l width-full bgcolor-eff1f1 relative"
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "nc-forward-chat-send",
                        attrs: { href: "javascript:void(0);" },
                        on: {
                          click: function($event) {
                            return _vm.forwardMessage()
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "hi-icon icon-chatright-arrow"
                        }),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", [_vm._v("Forward")])
                      ]
                    )
                  ]
                )
              ],
              2
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade forward-chat-modal email-chat-modal",
          attrs: {
            id: "basicModal1",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "basicModal1",
            "aria-hidden": "true"
          }
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(15),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "modal-body email-chat-main float-l width-full p_0"
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-group float-l width-full p_15" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email",
                            expression: "'required|email'"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.emailChat,
                            expression: "emailChat"
                          }
                        ],
                        staticClass: "form-control custom-select",
                        attrs: {
                          type: "email",
                          name: "email",
                          placeholder: "Your email address here",
                          onfocus: "this.placeholder = ''",
                          onblur: "this.placeholder = 'Your email address here'"
                        },
                        domProps: { value: _vm.emailChat },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.emailChat = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "help is-danger" }, [
                        _vm._v(_vm._s(_vm.emailChat_error_msg))
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "chat-forward-btm float-l width-full relative pl_15 pr_15"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-primary internal-large-btn float-l mr_20",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.sendChatEmail()
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "gradient" }),
                      _vm._v(" Send\n                    ")
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "more-btn btn btn-primary dropdown-toggle",
        attrs: { type: "button", "data-toggle": "dropdown" }
      },
      [
        _c("span", { staticClass: "more-dot" }),
        _vm._v(" "),
        _c("span", { staticClass: "more-dot" }),
        _vm._v(" "),
        _c("span", { staticClass: "more-dot" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-angle-right custom" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-angle-right custom" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-angle-right custom" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "back-btn-chat float-l" }, [
      _c("a", { attrs: { href: "javascript:void(0)" } }, [
        _c("i", { staticClass: "hi-icon icon-chatback" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "javascript:void(0)",
            "data-toggle": "modal",
            "data-target": "#basicModal1"
          }
        },
        [
          _c("span", [
            _c("i", { staticClass: "hi-icon icon-chatmail center width-full" })
          ]),
          _vm._v(" Email Chat ")
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "javascript:void(0)",
            "data-toggle": "modal",
            "data-target": "#basicModal"
          }
        },
        [
          _c("span", [
            _c("i", { staticClass: "hi-icon icon-chatsend center width-full" })
          ]),
          _vm._v(" Forward ")
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "hi-icon icon-chatend-chat center width-full" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      { staticClass: "dropdown-menu-profile middle-chat-query-section" },
      [
        _c("li", [
          _c("p", [
            _c("span", [_c("i", { staticClass: "fa fa-envelope-o" })]),
            _vm._v("  user@gmail.com ")
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("p", { staticClass: "phone-number-sec" }, [
            _c("span", [_c("i", { staticClass: "fa fa-phone" })]),
            _vm._v("  1234567890 ")
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "query-message" }, [
          _c("p", { staticClass: "query-section" }, [
            _c("span", [
              _c("i", {
                staticClass: "hi-icon icon-chatoval-speech-bubble",
                staticStyle: { "font-weight": "bold" }
              })
            ]),
            _vm._v(" Testing message subject ")
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "more-btn btn btn-primary dropdown-toggle",
        attrs: { type: "button", "data-toggle": "dropdown" }
      },
      [
        _c("span", { staticClass: "more-dot" }),
        _vm._v(" "),
        _c("span", { staticClass: "more-dot" }),
        _vm._v(" "),
        _c("span", { staticClass: "more-dot" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "javascript:void(0)",
            "data-toggle": "modal",
            "data-target": "#basicModal1"
          }
        },
        [
          _vm._v(" Email Chat "),
          _c("span", [_c("i", { staticClass: "fa fa-angle-right custom" })])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "javascript:void(0)",
            "data-toggle": "modal",
            "data-target": "#basicModal"
          }
        },
        [
          _vm._v(" Forward Chat "),
          _c("span", [_c("i", { staticClass: "fa fa-angle-right custom" })])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-angle-right custom" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "admin-typing colpie-82 float-l" }, [
      _c("div", { staticClass: "tiblock float-l" }, [
        _c("div", { staticClass: "tidot" }),
        _vm._v(" "),
        _c("div", { staticClass: "tidot" }),
        _vm._v(" "),
        _c("div", { staticClass: "tidot" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
      _vm._v(" "),
      _c("h4", { staticClass: "modal-title", attrs: { id: "myModalLabel" } }, [
        _vm._v("Email Chat To")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40329b07", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40329b07","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/List/ChatList.vue
// module id = null
// module chunks = 